import { EpimsBaseEntityDto } from './epim-base.dto';

export class PipelineAssetLocationDto extends EpimsBaseEntityDto {

  PipelineAssetLocationName: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  }
